<div
  class="label"
  [ngClass]="{
    warning: type === LabelType.Warning,
    information: type === LabelType.Information,
    note: type === LabelType.Note
  }"
  [style]="labelStyle"
>
  <ion-icon *ngIf="icon" class="icon" [name]="icon"></ion-icon>
  <ng-content *ngIf="type === LabelType.Custom"> </ng-content>
  <div *ngIf="type === LabelType.Custom && taskStatus !== null">
    <div *ngIf="taskStatus === TaskStatus.OFFEN">{{ 'label.offen' | translate }}</div>
    <div *ngIf="taskStatus === TaskStatus.FERTIG">{{ 'label.fertig' | translate }}</div>
    <div *ngIf="taskStatus === TaskStatus.ABGELEHNT">{{ 'label.abgelehnt' | translate }}</div>
  </div>
  <div *ngIf="type === LabelType.Custom && activityStatus !== null">
    <div *ngIf="activityStatus === ActivityStatus.OFFEN">{{ 'label.offen' | translate }}</div>
    <div *ngIf="activityStatus === ActivityStatus.ABGELEHNT">{{ 'label.abgelehnt' | translate }}</div>
    <div *ngIf="activityStatus === ActivityStatus.FERTIG">{{ 'label.fertig' | translate }}</div>
  </div>
  <div *ngIf="type !== LabelType.Custom">
    <div *ngIf="type === LabelType.Warning">{{ 'label.warnung' | translate }}</div>
    <div *ngIf="type === LabelType.Information">{{ 'label.hinweis' | translate }}</div>
    <div *ngIf="type === LabelType.Note">{{ 'label.notiz' | translate }}</div>
  </div>
</div>
